'use client';

import Link from 'next/link';
import { ArrowLeft, Home } from 'lucide-react';
import { TivitOrb } from '@/components/marketing-tivion/tivit-orb';

export default function NotFound() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-background">
      {/* Background gradient */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-navy/80 via-background to-background" />

      {/* Subtle grid pattern */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(79,209,229,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(79,209,229,0.3) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      <div className="relative z-10 flex flex-col items-center px-6 text-center">
        {/* Orb — scaled down */}
        <div className="scale-75 sm:scale-90">
          <TivitOrb />
        </div>

        {/* 404 text */}
        <h1 className="mt-2 bg-gradient-to-r from-shield-cyan via-shield-cyan-300 to-shield-cyan bg-clip-text text-7xl font-bold tracking-tighter text-transparent sm:text-8xl">
          404
        </h1>

        <h2 className="mt-4 text-xl font-semibold tracking-tight text-foreground sm:text-2xl">
          Page not found
        </h2>

        <p className="mt-2 max-w-md text-sm text-muted-foreground sm:text-base">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>

        {/* Action buttons */}
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            href="/"
            className="inline-flex items-center justify-center gap-2 rounded-lg bg-shield-cyan px-5 py-2.5 text-sm font-medium text-navy transition-all hover:bg-shield-cyan-400 hover:shadow-lg hover:shadow-shield-cyan/25"
          >
            <Home className="h-4 w-4" />
            Go home
          </Link>
          <button
            onClick={() => {
              if (typeof window !== 'undefined') window.history.back();
            }}
            className="inline-flex items-center justify-center gap-2 rounded-lg border border-border bg-background px-5 py-2.5 text-sm font-medium text-foreground transition-colors hover:bg-muted"
          >
            <ArrowLeft className="h-4 w-4" />
            Go back
          </button>
        </div>
      </div>
    </div>
  );
}
